<div class="p-4 surface-card border-round shadow-2">
    <!-- Bouton d'envoi pour signature -->
    @if (bskMode === true) {
        <button pButton class="w-full p-button p-button-primary p-component mb-4" icon="pi pi-send" label="{{'Sign_Send' | translate}}" (click)="openModal()"></button>
    }
    <!-- Tableau des utilisateurs -->
    <p-table [value]="users" class="w-full">
        <ng-template pTemplate="header">
            <tr>
                <th>{{'Sign_DestName' | translate}}</th>
                <th>{{'Cf_Uemail' | translate}}</th>
                <th>{{'Sign_Date' | translate}}</th>
                <th>{{'Sign_State' | translate}}</th>
                <th>{{'Action' | translate}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
            <tr>
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.updateDate | date:'dd/MM/yyyy HH:mm' }}</td>
                <td>
                    <span [ngClass]="user.statusColor" class="p-tag p-tag-rounded p-tag-lg">{{ user.status }}</span>
                </td>
                <td>
                    @if (user.status === 'NOT_SIGNED') {                        
                        <button
                            pButton
                            type="button"
                            icon="pi pi-refresh"
                            class="p-button-outlined p-button-primary p-button-icon-only"
                            pTooltip="{{'Sign_Rsend' | translate}}"
                            (click)="resendSignature(user)"
                        ></button>
                    }
                </td>
            </tr>
        </ng-template>
    </p-table>

    <!-- Modale de message -->
    <p-dialog
        appendTo="body"
        header="{{'Sign_Send' | translate}}"
        [(visible)]="displayModal"
        [modal]="true"
        [closable]="false"
        [style]="{width: '90vw', height: '90vh'}"
        [contentStyle]="{display: 'flex', flexDirection: 'row', overflow: 'hidden'}">
        <div class="grid w-full h-full">
            <!-- Colonne gauche : formulaire -->
            <div class="col-4 p-fluid" style="padding-right: 1rem;">
                <div class="field mb-3">
                    <label for="messageSubject">{{'Sign_Obj' | translate}}</label>
                    <input id="messageSubject" type="text" pInputText [(ngModel)]="messageSubject" placeholder="{{'Sign_ObjIn' | translate}}" />
                </div>
                <div class="field mb-3">
                    <label for="messageBody">{{'Sign_Corps' | translate}}</label>
                    <textarea id="messageBody" rows="4" pInputTextarea [(ngModel)]="messageBody" placeholder="{{'Sign_CorpsIn' | translate}}"></textarea>
                </div>
                <div class="field mb-3">
                    <label>{{'UsersD' | translate}}</label>
                    <p-tabView>
                        @if (allRecipients.length !== 0) {
                            <p-tabPanel header="{{'Internal' | translate}}">
                                <div class="flex align-items-center gap-3">                                
                                    <div class="flex-auto flex gap-3">
                                        <p-autoComplete
                                                class="flex-grow-1"
                                                [(ngModel)]="recipient"
                                                [suggestions]="filteredRecipients"
                                                (completeMethod)="filterRecipients($event)"
                                                field="fullName"
                                                appendTo="body"
                                                placeholder="{{'Find_Recipients' | translate}}">
                                        </p-autoComplete>
                                        <p-dropdown [options]="options" appendTo="body" [(ngModel)]="signType"></p-dropdown>
                                    </div>
                                </div>
                                <button pButton label="{{'Sign_Add' | translate}}" icon="pi pi-plus" class="mt-2" (click)="addRecipient()"></button>
                            </p-tabPanel>
                        }
                        <p-tabPanel header="{{'External' | translate}}">
                            <div class="field">
                                <input id="externalFirstLastName" type="text" pInputText [(ngModel)]="externalFirstLastName" placeholder="{{'FirstLastName' | translate}}"/>
                            </div>
                            <div class="field">
                                <input id="externalEmail" type="email" pInputText [(ngModel)]="externalEmail" placeholder="{{'Email_In' | translate}}" />
                            </div>
                            <div class="field">
                                <label for="externalOption">{{'Sign_Type' | translate}}</label>
                                <p-dropdown id="externalOption" [options]="options" appendTo="body" [(ngModel)]="signType" class="flex-grow-1"></p-dropdown>
                            </div>
                            <button pButton label="{{'Sign_Add' | translate}}"  icon="pi pi-plus" class="mt-2" (click)="addRecipient(true)"></button>
                        </p-tabPanel>
                    </p-tabView>
                </div>
                <div class="field mb-3">
                    <label>{{'Sign_SelRecipient' | translate}}</label>
                    <div class="selected-recipients" style="display: flex; flex-direction: column;">
                        <p-chip *ngFor="let recipient of selectedRecipients"
                                label="{{recipient.fullName}} ({{recipient.email}})"
                                removable="true"
                                (onRemove)="removeRecipient(recipient)">
                        </p-chip>
                    </div>
                </div>
            </div>

            <!-- Colonne droite : Aperçu du PDF avec Zone de Signature -->
            <div #divpdf class="col-8 pdf-container" style="position: relative; height: 100%;">
                <div style="position: relative; width: 100%; height: 100%;">
                    <pdf-preview style="position: relative;" [pathPdf]="pdfSrc"></pdf-preview>
                  </div>
            </div>
        </div>

        <p-footer>
            <button pButton label="{{'Cancel' | translate}}" icon="pi pi-times" class="p-button-text" (click)="closeModal()"></button>
            <button pButton label="{{'Send' | translate}}" icon="pi pi-check" (click)="sendMessage()" class="p-button-primary"></button>
        </p-footer>
    </p-dialog>
</div>
